<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">Devices</h4>
              <p class="card-category"></p>
              <button class="btn btn-info btn-fill float-right" id="show-modal" v-if="this.isAdmin===true"
                      v-on:click="addDevice()">Add
              </button>
            </template>
            <l-table-actions :actions="tableDevices.actions"
                             :columns="tableDevices.columns"
                             :data="tableDevices.data"
                             :selection-handler="tableDevices.selectionHandler"
                             class="table-hover table-striped">
            </l-table-actions>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">Map</h4>
            </template>
            <div id="map" class="map" style="height: 400px"></div>
          </card>
        </div>
      </div>
    </div>

    <l-modal-device-edit ref="modalEditDevice" :is-admin="this.isAdmin"/>
    <l-modal-device-params-edit ref="modalParameters" :is-admin="this.isAdmin"/>
    <l-modal-question ref="modalQuestion" :is-admin="this.isAdmin"/>

  </div>

</template>

<script>


  import LTableActions from 'src/components/TableActions.vue'
  import LModalDeviceEdit from 'src/components/Modal/ModalDeviceEdit'
  import LModalDeviceParamsEdit from 'src/components/Modal/ModalDeviceEditParams'
  import LModalQuestion from 'src/components/Modal/ModalQuestion'


  import Card from 'src/components/Cards/Card.vue'
  import 'vue-datetime/dist/vue-datetime.css'

  import EventBus from "../../event-bus";
  import {centerOfPoints} from "../../tools/MapTools";

  const Vue = window.Vue;

  const tableColumnsAdmin = ['Id', 'Name', 'Serial', 'Latitude', 'Longitude', 'User', 'Localization', 'Last Data Date'];
  const tableColumns = ['Id', 'Name', 'Serial', 'Latitude', 'Longitude', 'Localization', 'Last Data Date'];
  const tableData = [{}];
  const deviceTypeOptions = [
    {'key': 0, 'value': 'Test'},
    {'key': 1, 'value': 'Live'}
  ];


  export default {
    name: "DevicesPage",
    components: {
      LTableActions,
      Card,
      LModalDeviceEdit,
      LModalDeviceParamsEdit,
      LModalQuestion
    },
    data() {
      return {
        map: null,
        checked: false,
        idAdmin: false,
        tableDevices: {
          columns: [...tableColumns],
          data: [...tableData],
          actions: [
            {
              icon: 'database',
              handler: this.openData
            },
            {
              icon: 'chart-bar',
              handler: this.openCharts
            },
            {
              icon: 'edit',
              handler: this.editDevice
            },
            // {
            //     icon: 'tools',
            //     handler: this.editParams
            // },
            {
              icon: 'trash-alt',
              handler: this.deleteDeviceQuestion
            },
          ],
          selectionHandler: this.detailsItem
        },

        app: {
          colNum: 2,
          grids: Array.from({length: 5}, _ => 100 + 300 * Math.random())
        },
        deviceTypeOptions: [...deviceTypeOptions],
        device: {}
      }
    },

    mounted() {
      this.isAdmin = localStorage.getItem('isAdmin') === 'true';

      if (this.isAdmin === true) {
        this.tableDevices.columns = tableColumnsAdmin;
      }

      EventBus.$emit('EVENT_PATHS', [["/#/devices/list", 'Devices']])

      this.loadDevices();

      EventBus.$on('EVENT_RELOAD', data => {

        this.loadDevices();
      });
    },
    methods: {
      add() {
        this.grids.push(100 + 300 * Math.random());
      },
      remove() {
        this.grids.pop();
      },
      reset() {
        this.grids = Array.from({length: 5}, _ => 100 + 300 * Math.random());
      },

      loadDevices() {
        this.$http.get('device/list')
          .then(result => {
            this.tableDevices.data = result.data;
            this.initMap();
          }, error => {
            console.error(error);
          });
      },
      detailsItem(item) {
        this.$router.push('/devices/details/' + item.id);
      },
      editDevice(item) {
        this.$refs.modalEditDevice.editDevice(item);
      },
      editParams(item) {
        // this.$modal.show('modalParameters');
        this.$refs.modalParameters.editParams(item);
      },
      openData(item) {
        this.$router.push('/devices/data/' + item.id);
      },
      openCharts(item) {
        this.$router.push('/devices/charts/' + item.id);
      },
      deleteItem(item) {
        this.$http.delete('device/' + item.id)
          .then(result => {
            this.loadDevices();
          }, error => {
            console.error(error);
          });
      },
      onUserSelected() {
        this.loadLocationOptions();
      },
      addDevice() {
        this.$refs.modalEditDevice.addDevice();
      },
      /*closeAddModal() {
          this.$modal.show('modalParameters');
          // this.$refs.modalParameters.editParams(item);

      },*/
      deleteDeviceQuestion(item) {
        this.$refs.modalQuestion.openModalQuestion('Do you want to remove device: ' + item.name,
          item, this.deleteItem);
      },
      initMap() {
        let center = centerOfPoints(this.tableDevices.data);

        this.map = L.map('map').setView([center.latitude, center.longitude], center.zoom);
        this.tileLayer = L.tileLayer(
          'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          {
            maxZoom: 18,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
          }
        );
        this.tileLayer.addTo(this.map);

        for(let i = 0; i < this.tableDevices.data.length; i++) {
          let data = this.tableDevices.data[i];
          if (data.latitude !== null && data.latitude > 0 &&
            data.longitude !== null && data.longitude > 0) {
            let market = L.marker([data.latitude, data.longitude]).addTo(this.map);
            market.bindPopup(data.name);
          }
        }
      },
    }
  }

  function maxLengthCheck(object) {
    if (object.value.length > object.maxLength)
      object.value = object.value.slice(0, object.maxLength)
  }


</script>
<style>
  #show-modal-question {
    margin-right: 5px;
  }
</style>
